export enum AISummaryEvents {
  aiSummaryAddedToNote = 'AI Summary Added to Note',
  aiSummaryRatedPositively = 'AI Summary Rated Positively',
  aiSummaryRatedNegatively = 'AI Summary Rated Negatively',
  aiSummaryNegativeFeedbackSubmitted = 'AI Summary Negative Feedback Submitted',
  aiSummaryNegativeFeedbackCancelled = 'AI Summary Negative Feedback Cancelled',
  aiSummaryNegativeFeedbackClosed = 'AI Summary Negative Feedback Closed',
  aiSummaryRefreshButtonClicked = 'AI Summary Refresh Button Clicked',
  aiSummaryLearnMoreLinkClicked = 'AI Summary Learn More Link Clicked',
  aiSummaryToastDisplayed = 'AI Summary Toast Displayed',
  aiSummaryToastViewNoteClicked = 'AI Summary Toast View Note Clicked',
  aiSummaryToastDismissClicked = 'AI Summary Toast Dismiss Clicked',
  aiSummaryRealtimeUpdateReceived = 'AI Summary Realtime Update Received',
}
